import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Customer } from '@inyova/models';

import { select, Store } from '@ngrx/store';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import * as ProfileActions from '@profile/profile.actions';
import * as fromProfile from '@profile/profile.reducers';

import { AuthService } from '@shared/services/auth.service';

@Component({
  selector: 'app-profile-change-password',
  templateUrl: './profile-change-password.component.html',
  styleUrls: ['./profile-change-password.component.scss'],
  standalone: false
})
export class ProfileChangePasswordComponent implements OnInit, OnDestroy {
  private readonly onDestroy$ = new Subject<void>();
  formPass: FormGroup;
  isPasswordInvalid = true;
  showPass = { currentPass: false, newPass: false, newPassConf: false };
  submitted = false;
  emptyConfirmationPwd = false;
  loading = false;
  issue: string;
  @Input() customer: Customer;

  constructor(
    private formBuilder: FormBuilder,
    private store: Store,
    private authSerice: AuthService
  ) {
    this.store.pipe(select(fromProfile.selectProfilePasswordStatus), takeUntil(this.onDestroy$)).subscribe((status) => {
      this.loading = false;
      if (status === 'success') {
        this.submitted = false;
        this.resetPassValues();
        this.signoutCustomer();
      }
    });
  }

  ngOnInit(): void {
    this.formPass = this.formBuilder.group({
      currentPassword: ['', Validators.required],
      newPassword: ['', Validators.required],
      newPasswordConfirmation: ['', Validators.required]
    });
  }

  passVisibility(pass: string): void {
    this.showPass[pass] = !this.showPass[pass];
  }

  checkMatch(): void {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    if (this.formPass.value.newPasswordConfirmation !== this.formPass.value.newPassword) {
      this.issue = 'personal.flash.error_password';
      this.emptyConfirmationPwd = false;
    } else {
      this.emptyConfirmationPwd = true;
    }
  }

  submit(): void {
    // disable double click
    if (this.loading) {
      return;
    }

    const { currentPassword, newPassword, newPasswordConfirmation } = this.formPass.value;
    if (newPassword !== newPasswordConfirmation) {
      return;
    }

    if (!this.formPass.valid) {
      this.submitted = true;
      return;
    }

    if (this.isPasswordInvalid) {
      return;
    }

    this.loading = true;
    this.store.dispatch(
      ProfileActions.updateProfilePassword({
        currentPassword,
        newPassword,
        newPasswordConfirmation
      })
    );
  }

  resetPassValues(): void {
    this.formPass.setValue({
      currentPassword: '',
      newPassword: '',
      newPasswordConfirmation: ''
    });
  }

  onIsPasswordInvalid(event) {
    setTimeout(() => {
      this.isPasswordInvalid = event;
    });
  }

  signoutCustomer(): void {
    this.authSerice.logout();
  }

  ngOnDestroy(): void {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }
}
